import Api from '@/plugins/axios';
import { PaginatedRest, Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import {
  FiltroParecerReferencial,
  FiltroRelatorioPareceresVencidos,
  ParecerReferencial,
  ParecerReferencialList,
} from '../types';
import { ParecerReferencialRenovacao } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/parecer/referencial`;

class ParecerReferencialService {
  public async consultaParecerReferencial(
    cdParecerReferencial: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<Response<any>> {
    const url = `${BASE_URL}/${cdParecerReferencial}`;
    return handleApiResponse(() => Api.get(url));
  }

  public async excluirParecerReferencial(
    cdParecerReferencial: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<Response<any>> {
    const url = `${BASE_URL}/excluir/${cdParecerReferencial}`;
    return handleApiResponse(() => Api.delete(url));
  }

  public async cadastrarParecerReferencial(
    objetoParecerReferencial: ParecerReferencial,
    arquivo: FormData
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<Response<any>> {
    const parecerReferencialString = JSON.stringify(objetoParecerReferencial);
    const parecerReferencial = new FormData();
    parecerReferencial.append('parecerReferencial', parecerReferencialString);

    if (arquivo && arquivo instanceof HTMLInputElement && arquivo.files) {
      const anexo = arquivo.files[0];
      parecerReferencial.append('arquivo', anexo, arquivo.name);
    }

    const url = `${BASE_URL}/cadastrar/`;
    const configuracaoArquivo = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    return handleApiResponse(() =>
      Api.post(url, parecerReferencial, configuracaoArquivo)
    );
  }

  public async listar(data: FiltroParecerReferencial, page = 0, size = 10) {
    return Api.get<PaginatedRest<ParecerReferencialList>>(
      `${BASE_URL}/listar`,
      {
        params: { page, size, ...data },
      }
    );
  }

  public async downloadRelatorioPareceresVencidos(
    data: FiltroRelatorioPareceresVencidos
  ) {
    const urlRelatorio = `${window.location.origin}/mat-report/gcn/api/v1.0/parecer_referencial/validade`;
    return Api.get(urlRelatorio, {
      params: {
        ...data,
      },
      responseType: 'blob',
    });
  }

  async findExtensoesAceitas() {
    return Api.get<string[]>(`${BASE_URL}/extensoes`);
  }

  async cadastrar(parecerReferencial: ParecerReferencial, arquivo: File) {
    return Api.postForm<number>(`${BASE_URL}/cadastrar`, {
      parecerReferencial: JSON.stringify(parecerReferencial),
      arquivo,
    });
  }

  async editar(
    cdParecerReferencial: number,
    parecerReferencial?: ParecerReferencial,
    parecerReferencialRenovacao?: ParecerReferencialRenovacao[],
    arquivo?: File
  ) {
    return Api.postForm<ParecerReferencial>(`${BASE_URL}/editar`, {
      cdParecerReferencial,
      parecerReferencial: JSON.stringify(parecerReferencial),
      parecerReferencialRenovacao: JSON.stringify(parecerReferencialRenovacao),
      arquivo,
    });
  }

  async buscar(cdParecerReferencial: number) {
    return await Api.get<ParecerReferencial>(
      `${BASE_URL}/buscar/${cdParecerReferencial}`
    );
  }

  getUrlDownload(cdParecerReferencial: number) {
    return `${BASE_URL}/${cdParecerReferencial}/documento`;
  }
}

export default new ParecerReferencialService();
